import {FILTERS_GROUPS_IDS} from '../../common/filtersGroups.js'
import {FILTER_NAMES} from '../ads.js'

export const SECOND_HAND_VEHICLES_LISTING_SECTION_FILTERS_GROUPS = {
  [FILTERS_GROUPS_IDS.MAKE_GROUP_ID]: {
    icon: 'carBrand',
    label: 'FILTERS_GROUPS.MAKE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.VEHICLES]
  },
  [FILTERS_GROUPS_IDS.PRICE_GROUP_ID]: {
    icon: 'tag',
    label: 'FILTERS_GROUPS.PRICE.LABEL.DEFAULT',
    filters: [
      FILTER_NAMES.INSTALMENT,
      FILTER_NAMES.HAS_INSTALMENT,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_PRICE_DROP,
      FILTER_NAMES.PRICE_RANK
    ]
  },
  [FILTERS_GROUPS_IDS.ONLINE_SERVICES_GROUP_ID]: {
    icon: 'cursorClick',
    label: 'FILTERS_GROUPS.ONLINE_SERVICES.LABEL.DEFAULT',
    filters: [FILTER_NAMES.HAS_RESERVATION, FILTER_NAMES.HAS_ONLINE_FINANCING]
  },
  [FILTERS_GROUPS_IDS.LOCATION_GROUP_ID]: {
    icon: 'poi',
    label: 'FILTERS_GROUPS.LOCATION.LABEL.DEFAULT',
    filters: [FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID, FILTER_NAMES.ONLY_PENINSULA]
  },
  [FILTERS_GROUPS_IDS.SELLER_GROUP_ID]: {
    icon: 'shieldCheck',
    label: 'FILTERS_GROUPS.SELLER.LABEL.DEFAULT',
    filters: [
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.RATING,
      FILTER_NAMES.HAS_WARRANTY,
      FILTER_NAMES.IS_CERTIFIED,
      FILTER_NAMES.HAS_STOCK,
      FILTER_NAMES.HAS_PHOTO
    ]
  },
  [FILTERS_GROUPS_IDS.YEAR_GROUP_ID]: {
    icon: 'calendar',
    label: 'FILTERS_GROUPS.YEAR.LABEL.DEFAULT',
    filters: [FILTER_NAMES.YEAR]
  },
  [FILTERS_GROUPS_IDS.KMS_GROUP_ID]: {
    icon: 'kmOdometer',
    label: 'FILTERS_GROUPS.KMS.LABEL.DEFAULT',
    filters: [FILTER_NAMES.KMS]
  },
  [FILTERS_GROUPS_IDS.BODY_TYPE_GROUP_ID]: {
    icon: 'doors',
    label: 'FILTERS_GROUPS.BODY_TYPE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.BODY_TYPE, FILTER_NAMES.DOOR, FILTER_NAMES.SEAT, FILTER_NAMES.LUGGAGE_CAPACITY]
  },
  [FILTERS_GROUPS_IDS.MOTOR_GROUP_ID]: {
    icon: 'carEngine',
    label: 'FILTERS_GROUPS.ENGINE.LABEL.DEFAULT',
    filters: [
      FILTER_NAMES.TRANSMISSION_TYPE,
      FILTER_NAMES.FUEL_TYPE,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.HP,
      FILTER_NAMES.DRIVEN_WHEELS
    ]
  },
  [FILTERS_GROUPS_IDS.ENVIRONMENTAL_LABEL_GROUP_ID]: {
    icon: 'ecoLeaf',
    label: 'FILTERS_GROUPS.ENVIRONMENTAL_LABEL.LABEL.DEFAULT',
    filters: [FILTER_NAMES.ENVIRONMENTAL_LABEL]
  },
  [FILTERS_GROUPS_IDS.ELECTRIC_GROUP_ID]: {
    icon: 'electric',
    label: 'FILTERS_GROUPS.ELECTRIC.LABEL.DEFAULT',
    filters: [
      FILTER_NAMES.ELECTRIC_AUTONOMY,
      FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY,
      FILTERS_GROUPS_IDS.ELECTRIC_CHARGING_TIME_GROUP_ID
    ]
  },
  [FILTERS_GROUPS_IDS.EQUIPMENT_GROUP_ID]: {
    icon: 'carExtras',
    label: 'FILTERS_GROUPS.EQUIPMENT.LABEL.DEFAULT',
    filters: [FILTER_NAMES.EQUIPMENTS]
  },
  [FILTERS_GROUPS_IDS.COLOR_GROUP_ID]: {
    icon: 'palette',
    label: 'FILTERS_GROUPS.COLOR.LABEL.DEFAULT',
    filters: [FILTER_NAMES.COLOR]
  }
}
